<template>
  <v-card flat>
    <v-card-text class="pt-0">
      <v-form ref="form" :disabled="!candidato.pode_atualizar_docs">
        <v-card flat>
          <v-card-title class="subtitle-1 font-weight-bold primary--text"
            >Complemento dos dados</v-card-title
          >
          <v-card-text class="pb-0">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  label="RG"
                  v-model="candidato.rg"
                  v-mask="'##########'"
                ></v-text-field>
              </v-col>
              <v-col xl="4" lg="4" md="4" cols="12">
                <v-text-field
                  label="*Endereço"
                  v-model="candidato.endereco"
                  :rules="[
                    (v) => v.length > 3 || 'Endereço deve ser informado',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col xl="2" lg="2" md="2" cols="12">
                <v-text-field
                  label="Número"
                  v-model="candidato.numero"
                  v-mask="'######'"
                ></v-text-field>
              </v-col>
              <v-col xl="3" lg="3" md="3" cols="12">
                <v-text-field
                  label="Bairro"
                  v-model="candidato.bairro"
                ></v-text-field>
              </v-col>
              <v-col xl="3" lg="3" md="3" cols="12">
                <v-text-field
                  label="CEP"
                  v-model="candidato.cep"
                  v-mask="'##.###-###'"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card flat>
          <v-card-title class="subtitle-1 font-weight-bold primary--text"
            >Anexos</v-card-title
          >
          <v-card-text>
            <v-file-input
              label="Comprovante de Residência"
              messages="Incluir cópia legível do seu comprovante de endereço atualizado"
              v-model="anexos.comprovante_residencia"
              :success="candidato.imgcomprovresidInfo"
              :append-icon="candidato.imgcomprovresidInfo ? 'mdi-check' : ''"
            ></v-file-input>
            <v-file-input
              label="CPF"
              messages="Incluir cópia legível do seu CPF"
              v-model="anexos.cpf"
              :success="candidato.imgCPFFrenteInfo"
              :append-icon="candidato.imgCPFFrenteInfo ? 'mdi-check' : ''"
            ></v-file-input>
            <v-file-input
              label="RG Frente"
              messages="Incluir cópia legível do seu RG - Frente"
              v-model="anexos.rg_frente"
              :success="candidato.imgRGFrenteInfo"    
              :append-icon="candidato.imgRGFrenteInfo ? 'mdi-check' : ''"          
            ></v-file-input>
            <v-file-input
              label="RG Verso"
              messages="Incluir cópia legível do seu RG - Verso"
              v-model="anexos.rg_verso"
              :success="candidato.imgRGVersoInfo"
              :append-icon="candidato.imgRGVersoInfo ? 'mdi-check' : ''"
            ></v-file-input>
            <v-file-input
              label="Histórico escolar"
              messages="Incluir cópia legível do histórico escolar"
              v-model="anexos.historico_escolar"
              :success="candidato.imgHistEscolarInfo"
              :append-icon="candidato.imgHistEscolarInfo ? 'mdi-check' : ''"
            ></v-file-input>
          </v-card-text>
        </v-card>

        <v-card
          flat
          rounded="lg"
          class="grey lighten-4 mt-2"
          v-if="isSelecMotorista()"
        >
          <v-card-title class="font-weight-bold subtitle-1 primary--text"
            >Dados CNH</v-card-title
          >
          <v-card-text>
            <v-row dense>
              <v-col xl="4" lg="4" md="4" cols="12">
                <v-text-field
                  label="Número CNH"
                  v-model="candidato.numerocnh"
                  v-mask="'###########'"
                ></v-text-field>
              </v-col>
              <v-col xl="4" lg="4" md="4" cols="12">
                <v-select
                  label="Categoria"
                  :items="categorias_cnh"
                  item-text="descricao"
                  item-value="codigo"
                  v-model="candidato.categoriacnh"
                  no-data-text="Nenhuma categoria disponível"
                ></v-select>
              </v-col>
              <v-col xl="4" lg="4" md="4" cols="12">
                <v-text-field
                  label="Validade CNH"
                  type="date"
                  v-model="candidato.dtvalidcnh"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  label="Anexo CNH Frente"
                  messages="Incluir cópia legível da CNH"
                  v-model="anexos.cnh"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card flat rounded="lg" class="teal lighten-5 mt-3">
          <v-card-title class="subtitle-1 font-weight-bold teal--text"
            >Qualificação cadastral</v-card-title
          >
          <v-card-text>
            <btn-consulta-qualif-cadastral />

            <v-file-input
              class="mt-2"
              label="Anexo qualificação cadastral"
              messages="Incluir cópia legível da qualificação cadastral gerada através do processo de qualificação"
              v-model="anexos.qualificacao_cadastral"
            ></v-file-input>
          </v-card-text>
        </v-card>

        <v-row dense class="mt-4" v-if="candidato.pode_atualizar_docs">
          <v-col cols="12">
            <v-btn
              rounded
              block
              depressed
              class="green lighten-4 font-weight-bold primary--text"
              @click="enviarInscricao()"
              :loading="inscrevendo"
              >Enviar documentos</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import BtnConsultaQualifCadastral from "./botoes/BtnConsultaQualifCadastral.vue";
export default {
  components: {
    BtnConsultaQualifCadastral,
  },
  computed: {
    ...mapState(["anexos", "candidato", "categorias_cnh"]),
  },
  data: () => ({
    inscrevendo: false,
  }),
  methods: {
    ...mapActions(["confirmarInscricao"]),
    isSelecMotorista() {
      return (
        this.candidato.areasinteresse.filter((value) => value.motorista)
          .length > 0
      );
    },
    async enviarInscricao() {
      if (this.$refs.form.validate()) {
        this.inscrevendo = true;
        var insc = await this.confirmarInscricao();
        if (insc) {
          this.$router.go();
        }
        this.inscrevendo = false;
      }
    },
  },
};
</script>

<style>
</style>

